const BalloonSVG = ({ color = '#FF6384', size = 40 }) => (
    <svg
      width={size}
      height={size * 1.5}
      viewBox="0 0 64 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="32" cy="32" rx="30" ry="32" fill={color} />
      <line x1="32" y1="64" x2="32" y2="96" stroke={color} strokeWidth="2" />
    </svg>
  );  

  export default BalloonSVG;